<div
  class="kl-field"
  [class.kl-field--my-3]="marginY()"
  [class.kl-field--mb-2]="marginBottom()"
  [formGroup]="formGroup()">
  @if (label()) {
    <kl-label
      [label]="label()"
      [labelDescription]="labelDescription()"
      [isRequired]="required()"
      [htmlFor]="fieldId()" />
  }

  <div class="kl-field__control text-start">
    <textarea
      pTextarea
      [id]="fieldId()"
      [rows]="rows()"
      [autoResize]="autoResize()"
      [formControlName]="controlName()"
      [placeholder]="placeholder() | translate"
      [attr.minlength]="minlength() ?? null"
      [attr.maxlength]="maxlength() ?? null"
      [invalid]="showInvalid()"
      [fluid]="true"
      (input)="onAnyChange()"></textarea>
  </div>

  <div class="kl-field__error text-start">
    @if (showFieldError() && controlError()) {
      <span>{{ controlError() }}</span>
    }
  </div>
</div>
